__turbopack_context__.v({
  "grid": "PlpProductGrid-module-scss-module__FfKVzW__grid",
  "grid__empty": "PlpProductGrid-module-scss-module__FfKVzW__grid__empty",
});
